// A month as a chip select (APS-412, admin-d.md "Dates and months"): the last 24 months, newest
// first, named in the page's language ("outubro de 2026"); never a native month input, which
// speaks the browser's language. Values are `YYYY-MM`, UTC.
import { SelectChip } from '@apsio/ui'
import { useI18n } from '../../i18n'

/** The last `count` months up to `now`'s, newest first, as `YYYY-MM` (UTC). */
export function lastMonths(now: Date, count = 24): string[] {
  const out: string[] = []
  for (let i = 0; i < count; i++) {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1))
    out.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`)
  }
  return out
}

export function MonthChip({
  value,
  onChange,
  label,
  now = new Date(),
}: {
  value: string
  onChange: (month: string) => void
  /** The select's name for a screen reader; defaults to "Mês". */
  label?: string | undefined
  now?: Date | undefined
}) {
  const { t, date } = useI18n()
  const months = lastMonths(now)
  // A month older than the list (a link from elsewhere) stays choosable.
  if (value && !months.includes(value)) months.push(value)
  return (
    <SelectChip label={label ?? t('kit.month.label')} value={value} onChange={onChange}>
      {months.map((m) => (
        <option key={m} value={m}>
          {date(`${m}-01T00:00:00Z`, { month: 'long', year: 'numeric', timeZone: 'UTC' })}
        </option>
      ))}
    </SelectChip>
  )
}
